import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPagination from 'react-js-pagination';
import { loadThreeWayCalls } from '../../../../actions/three_way';

function Pagination({ user = {} }) {
  const dispatch = useDispatch();
  const {
    Page: callPageIdx,
    PageSize: callPageSize,
    TotalItems,
  } = useSelector(store => store.threeWay.callData);


  function handleChange(paginationIdx) {
    if (paginationIdx === callPageIdx) return;
    dispatch({ type: 'SET_THREE_WAY_LOADING', payload: true });
    loadThreeWayCalls(user.username, { page: paginationIdx })
      .then(config => {
        dispatch({ type: 'SET_THREE_WAY_FIELD_VALUE', field: 'callData', payload: config });
        dispatch({ type: 'SET_THREE_WAY_LOADING', payload: false });
      }).catch(() => {
        dispatch({ type: 'SET_THREE_WAY_LOADING', payload: false });
      });
  }

  return (
    <ReactPagination
      activePage={callPageIdx}
      itemsCountPerPage={callPageSize}
      totalItemsCount={TotalItems || 0}
      pageRangeDisplayed={5}
      linkClass="page-link"
      onChange={(p) => handleChange(p)}
    />
  );
}

export default Pagination;
